module.exports = __webpack_public_path__ + "static/app-store-badge-1cfd5dba4a9210bcf77f5dbe48ec2e66.svg";